module.exports = __webpack_public_path__ + "media/images/ibu__logo__secondary-5aaf682c14ff6558a64f6d809647d5ac.svg";